import '@vaadin/vaadin-time-picker/vaadin-time-picker';
import React from 'react';
// import ReactDOM from 'react-dom';

// @ts-ignore
const template = document.createElement('template');

template.innerHTML = `
  <style>
   .button-container {
      /*text-align: center;*/
      display: flex;
      /*justify-content: center;*/
      place-items: center;
    }
    
    /*.container {*/
    /*  width: 60px !important;*/
    /*  !*overflow: hidden;*!*/
    /*  font-size: 10px !important;*/
    /*}*/
    
    /*.vaadin-text-field-container, .vaadin-text-area-container {*/
    /*  min-width: 80px !important;*/
    /*  max-width: 80px !important;*/
    /*}*/
    
    /*vaadin-time-picker-text-field {*/
    /*  width: 80px !important;*/
    /*  font-size: 10px !important;*/
    /*}*/
  </style>

  <div class="container">
    <vaadin-time-picker value="11:11" clear-button-visible></vaadin-time-picker>
    <vaadin-time-picker value="11:12" clear-button-visible></vaadin-time-picker>
    <vaadin-time-picker value="11:13" clear-button-visible></vaadin-time-picker>
    <vaadin-time-picker value="11:14" clear-button-visible></vaadin-time-picker>
    <vaadin-time-picker value="11:15" clear-button-visible></vaadin-time-picker>
  </div>
`;

class XTime5 extends HTMLElement {
  private $container: any;
  private root: ShadowRoot;

  constructor() {
    super();

    this.root = this.attachShadow({ mode: 'open' });
    this.root.appendChild(template?.content?.cloneNode(true));

    this.$container = this.root.querySelector('.container');
  }

  connectedCallback() {}

  attributeChangedCallback() {
    this.render();
  }

  render() {
    // this.$button!.innerHTML = this.label as string;
  }
}

const customElementName = 'x-time5';
if (!customElements.get(customElementName)) customElements.define(customElementName, XTime5);
